export default "__VITE_ASSET__Cui8k9oh__";